module.exports = __webpack_public_path__ + "img/project-passiveHouse.70013fa2.jpg";